import ApiUtil from '../utils/ApiUtil';
import { userSalesUnitUrls } from 'constants/apiEndPoints';
import { type SalesUintResponse } from 'pages/Orders/SalesOrder';



const addSalesUintRequest = async (salesUnitInfo: unknown[]): Promise<unknown> => {
    const request = await ApiUtil.postWithToken(userSalesUnitUrls.createSalesUnits, salesUnitInfo);
    return request;
};

const getAllUserSalesUnit = async (page: number, size: number): Promise<SalesUintResponse> => {
    const salesUint = await ApiUtil.getWithToken(`${userSalesUnitUrls.getAllUserSaleUints}?page=${page}&size=${size}`) as SalesUintResponse;
    return salesUint
}

const getAllDetailedUserSalesUnit = async (page: number, size: number, fundId: number,): Promise<SalesUintResponse> => {
    const salesUint = await ApiUtil.getWithToken(`${userSalesUnitUrls.getAllDetailedUserSaleUnits}?page=${page}&size=${size}&fundId=${fundId}`) as SalesUintResponse;
    return salesUint
}

export {

    addSalesUintRequest,
    getAllUserSalesUnit,
    getAllDetailedUserSalesUnit
}